import { render, staticRenderFns } from "./VoteExampleItem.vue?vue&type=template&id=0b4919f4&"
import script from "./VoteExampleItem.vue?vue&type=script&lang=js&"
export * from "./VoteExampleItem.vue?vue&type=script&lang=js&"
import style0 from "./VoteExampleItem.vue?vue&type=style&index=0&id=0b4919f4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports